import React, { useState, useEffect } from 'react';
import { PartyPopper, Award, Flame, Loader2 } from 'lucide-react';
import { apiClient } from '../../api/client';

const ParentCelebrationAlerts = () => {
  const [alerts, setAlerts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiClient.request('/api/enhancements/parent-alerts')
      .then(data => setAlerts(data.alerts || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return null;
  if (alerts.length === 0) return null;

  const iconMap = {
    badge_earned: <Award size={18} className="text-yellow-500" />,
    streak_milestone: <Flame size={18} className="text-orange-500" />,
  };

  const bgMap = {
    badge_earned: 'bg-yellow-50 border-yellow-200',
    streak_milestone: 'bg-orange-50 border-orange-200',
  };

  return (
    <div className="card" data-testid="parent-celebration-alerts">
      <div className="card-header">
        <div className="flex items-center gap-2">
          <PartyPopper size={18} className="text-pink-500" />
          <h3 className="card-title text-base">Celebration Alerts</h3>
          <span className="text-xs bg-pink-100 text-pink-700 px-2 py-0.5 rounded-full font-bold">{alerts.length} new</span>
        </div>
      </div>
      <div className="space-y-2">
        {alerts.slice(0, 5).map((alert, i) => (
          <div
            key={i}
            className={`p-3 rounded-xl border flex items-center gap-3 ${bgMap[alert.type] || 'bg-gray-50 border-gray-200'}`}
          >
            {iconMap[alert.type] || <PartyPopper size={18} className="text-pink-500" />}
            <div className="flex-1">
              <p className="text-sm font-semibold text-gray-900">{alert.title}</p>
              <p className="text-xs text-gray-500">{alert.teen_name}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ParentCelebrationAlerts;
